module.exports = __webpack_public_path__ + "static/img/icon_gacx.5863748.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/index/icon_gacx.png
// module id = 5xtD
// module chunks = 11